/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assetlibrarypickerdescription3Inputs */

const en_assetlibrarypickerdescription3 = /** @type {(inputs: Assetlibrarypickerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick an image you created with the AI Studio tools.`)
};

const de_assetlibrarypickerdescription3 = /** @type {(inputs: Assetlibrarypickerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Bild, das du mit den KI-Studio-Werkzeugen erstellt hast.`)
};

/**
* | output |
* | --- |
* | "Pick an image you created with the AI Studio tools." |
*
* @param {Assetlibrarypickerdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const assetlibrarypickerdescription3 = /** @type {((inputs?: Assetlibrarypickerdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assetlibrarypickerdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assetlibrarypickerdescription3(inputs)
	return de_assetlibrarypickerdescription3(inputs)
});
export { assetlibrarypickerdescription3 as "assetLibraryPickerDescription" }